<template>
  <div class="container--full">
    <transition name="main-menu-search">
      <section class="main-menu-search__wrapper">
        <img
          @click="searchSubmit()"
          class="lazyload main-menu-search__submit"
          :class="{ 'is-disabled': !searchAllowSubmit }"
          alt=""
          :data-src="searchBarIconSearch"
          role="img">
        <label
          for="search-field"
          class="main-menu-search__label is-sr-only">
          {{ searchBarPlaceholder }}
        </label>
        <input
          id="search-field"
          :placeholder="searchBarPlaceholder"
          aria-describedby="search-field-help"
          @keyup.enter="searchSubmit()"
          autocomplete="off"
          class="main-menu-search__input"
          ref="searchInput"
          type="search"
          :maxlength="searchValueMaxLength"
          @input="getSearchLength($event)"
          v-model="searchValue">
        <div v-show="showLoader">
          <img :data-src="searchBarIconLoading" alt="Loading icon" class="lazyload search-loading">
        </div>
        <transition name="main-menu-fade">
          <p
            id="search-field-help"
            v-if="!searchAllowSubmit"
            class="main-menu-search__help">
            {{ searchBarHelpText }}
          </p>
        </transition>
        <transition name="main-menu-fade">
          <button
            v-show="searchValueLength > 0"
            @click="searchClear"
            class="main-menu-search__clear"
            :aria-label="searchBarA11yAriaLabelClear">
            <img
              alt=""
              class="lazyload main-menu-search__close-icon"
              role="img"
              :data-src="searchBarIconClear">
            {{ searchBarClearLabel }}
          </button>
        </transition>
      </section>
    </transition>
  </div>
</template>

<script>
  import { AnalyticsHandler } from '@Foundation/analyticsHandler';
  export default {
    name: 'search-bar',
    directives: {
      AnalyticsHandler
    },
    props: {
      tagging: {
        required: true,
        type: Object
      },
      searchBarA11yAriaLabelClear: {
        type: String,
        required: false,
        default: 'Clear search field'
      },
      searchBarClearLabel: {
        type: String,
        required: false,
        default: 'Clear'
      },
      searchBarHelpText: {
        type: String,
        required: false,
        default: 'Please enter at least 3 characters'
      },
      searchBarIconClear: {
        type: String,
        required: false,
        default: '/assets/cross-icon.svg'
      },
      searchBarIconSearch: {
        type: String,
        required: false,
        default: '/assets/magnifier-icon.svg'
      },
      searchBarPlaceholder: {
        type: String,
        required: false,
        default: 'Start Typing Here..'
      },
      searchBarRedirectUrl: {
        type: String,
        required: false,
        default: '#'
      },
      searchBarIconLoading: {
        type: String,
        required: false,
        default: '/images/icons/search-loader-icon.gif'
      }
    },
    data() {
      return {
        searchValue: '',
        searchValueLength: 0,
        searchValueMaxLength: 200,
        showLoader: false,
      };
    },
    computed: {
      /**
       * If the search value is allowed to be submitted
       * @returns {boolean}
       */
      searchAllowSubmit() { 
        return this.searchValueLength >= 3 && this.searchValueLength < this.searchValueMaxLength; 
      },

      /**
       * Appends the search value to propped redirect url
       * @returns {string}
       */
      searchUrl() {
        return this.searchBarRedirectUrl.concat(encodeURIComponent(this.searchValue));
      }
    },
    methods: {
      /**
       * Sets the length of the search Input
       * * @returns {undefined}
       */
      getSearchLength(e) {
        this.$nextTick(() => {
          this.searchValueLength = e.target.value.length;
        });
      },

      /**
       * Clear the user search value
       * * @returns {undefined}
       */
      searchClear() {
        this.searchValue = '';
        this.searchFocus();
      },

      /**
       * Focuses the search bar input field
       * @returns {undefined}
       */
      searchFocus() {
        this.$nextTick(() => {
          this.$refs.searchInput.focus();
        });
      },

      /**
       * Redirects to Sitecore page for handeling the search request
       * @returns {undefined}
       */
      searchSubmit() {
        if (this.searchAllowSubmit) {
          this.showLoader = true;
          const searchEventTag = this.tagging;
          searchEventTag.eventLabel = this.searchValue;
          AnalyticsHandler.pushDataLayer(searchEventTag);
          setTimeout(() => {
            window.location.assign(this.searchUrl);
          }, 1500);
        }
      },
    }
  };
</script>
<style src="./search.scss" lang="scss"></style>
